<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3 class="page-title">Witaj w Stopkomat CRM</h3>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {

    };
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
};
</script>

